@if (visible && config) {
<!-- Toast notifications (success, error, warning, info) -->
@if (config.type !== 'confirm') {
<div class="toast-container">
    <div class="toast" [ngClass]="'toast-' + config.type">
        <div class="toast-icon" [ngClass]="'icon-' + config.type">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path [attr.d]="getIcon()"></path>
            </svg>
        </div>
        <div class="toast-content">
            <h3 class="toast-title">{{ config.title }}</h3>
            @if (config.message) {
            <p class="toast-message">{{ config.message }}</p>
            }
        </div>
        <button class="toast-close" (click)="close()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path
                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z">
                </path>
            </svg>
        </button>
    </div>
</div>
}

<!-- Modal for confirm dialogs -->
@if (config.type === 'confirm') {
<div class="notification-overlay" (click)="close()">
    <div class="notification-modal" (click)="$event.stopPropagation()" [ngClass]="'modal-' + config.type">
        <!-- Icon -->
        <div class="modal-icon" [ngClass]="'icon-' + config.type">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path [attr.d]="getIcon()"></path>
            </svg>
        </div>

        <!-- Content -->
        <div class="modal-content">
            <h2 class="modal-title">{{ config.title }}</h2>
            @if (config.message) {
            <p class="modal-message">{{ config.message }}</p>
            }
        </div>

        <!-- Actions -->
        <div class="modal-actions">
            <button class="btn btn-secondary" (click)="cancel()">
                {{ config.cancelText || 'Cancelar' }}
            </button>
            <button class="btn btn-primary" (click)="confirm()">
                {{ config.confirmText || 'Confirmar' }}
            </button>
        </div>
    </div>
</div>
}
}